import React from 'react';
import { Base, LoadingSkeletonProps } from '../../Base/Base';
import { Shimmer } from '../../Shimmer/Shimmer';

export const Box = ({ shouldShimmer, ...baseProps }: LoadingSkeletonProps) => {
  return (
    <Base {...baseProps}>
      <Shimmer shouldShimmer={shouldShimmer} />
    </Base>
  );
};
